var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 16,
    viewBox: "0 0 3 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57166 9C2.12394 9 2.57166 8.55228 2.57166 8C2.57166 7.44771 2.12394 7 1.57166 7C1.01937 7 0.571655 7.44771 0.571655 8C0.571655 8.55228 1.01937 9 1.57166 9Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57166 2C2.12394 2 2.57166 1.55228 2.57166 1C2.57166 0.447715 2.12394 0 1.57166 0C1.01937 0 0.571655 0.447715 0.571655 1C0.571655 1.55228 1.01937 2 1.57166 2Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57166 16C2.12394 16 2.57166 15.5523 2.57166 15C2.57166 14.4477 2.12394 14 1.57166 14C1.01937 14 0.571655 14.4477 0.571655 15C0.571655 15.5523 1.01937 16 1.57166 16Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.556f34a83c4e85e02e37800a47984439.svg";
export { ForwardRef as ReactComponent };